module.exports = __webpack_public_path__ + "img/2.98017b78.png";